import { z } from 'zod';

/** Matches the backend `CreateUserGroupRequest.name` / `RenameUserGroupRequest.name` limit */
export const USER_GROUP_NAME_MAX_LENGTH = 255;

export const userGroupFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'authenticated.settings:pages.permissions.groupModal.errors.nameRequired')
    .max(
      USER_GROUP_NAME_MAX_LENGTH,
      'authenticated.settings:pages.permissions.groupModal.errors.nameTooLong'
    ),
});

export type UserGroupFormValues = z.infer<typeof userGroupFormSchema>;

/**
 * The replacement group is unconditionally required — the backend needs somewhere to move
 * the deleted group's members. Kept as a string because SingleSelect emits strings; the
 * conversion to a number happens at submit time.
 */
export const deleteUserGroupSchema = z.object({
  replacementGroupId: z
    .string()
    .min(1, 'authenticated.settings:pages.permissions.deleteGroupModal.replacementRequired'),
});

export type DeleteUserGroupFormValues = z.infer<typeof deleteUserGroupSchema>;
